import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatingLeftColumnComponent } from './floating-left-column.component';

@NgModule({
    imports: [CommonModule],
    declarations: [FloatingLeftColumnComponent],
    exports: [FloatingLeftColumnComponent],
})
export class FloatingLeftColumnModule {}
